export const getMargin=t=>`calc(${15.25*t}pt + 1px * ${t-1})`;